import React from "react";

import {
  styled,
  Box,
  Container,
  Tabs as MuiTabs,
  Tab as MuiTab,
} from "@mui/material";

import Layout from "components/common/Layout";
import BannerEditor from "components/article/BannerEditor";
import ArticlesList from "components/article/ArticlesList";

const Tabs = styled(MuiTabs)(
  ({ theme }) => `
    margin: ${theme.spacing(-1, 0)};
    min-height: 56px;
  `
);

const Tab = styled(MuiTab)`
  min-height: 56px;
`;

export default function ArticlesPage() {
  const [tab, setTab] = React.useState("banner");

  return (
    <Container fixed sx={{ position: "relative" }}>
      <Layout.Toolbar fixed>
        <Tabs
          value={tab}
          onChange={(evt, value) => {
            window.scrollTo({ top: 0 });
            setTab(value);
          }}
          variant="fullWidth"
        >
          <Tab value="banner" label="Banière" />
          <Tab value="artist" label="Artistes" />
          <Tab value="blogPost" label="Posts de blog" />
          <Tab value="page" label="Pages" />
        </Tabs>
      </Layout.Toolbar>

      {tab === "banner" ? (
        <Box sx={{ padding: (t) => ({ xs: 2, sm: t.spacing(2, 3) }) }}>
          <BannerEditor />
        </Box>
      ) : (
        <ArticlesList type={tab} />
      )}
    </Container>
  );
}
